import { useFormik } from 'formik';
import { useTemplateContext } from '../context/TemplateContext';

const useUploadTemplateForm = () => {
    const { selectedTemplate, templateFileUploadSaveHandler } = useTemplateContext();

    const formik = useFormik({
        initialValues: {
            demandType: selectedTemplate?.demandType || '',
            caseType: selectedTemplate?.caseType || '',
            state: selectedTemplate?.state || '',
            templateDoc: [],
        },
        enableReinitialize: true,
        onSubmit: ({ caseType, demandType, state }) => {
            templateFileUploadSaveHandler({ caseType, demandType, state });
        },
    });

    return { formik };
};

export default useUploadTemplateForm;
